import { createSelector } from '@ngrx/store';
import { RegisterStateInterface } from './register.state';
import { getRegister } from '../auth.selectors';

export const getIsRegisterSuccess = createSelector(
  getRegister,
  (state: RegisterStateInterface) => state.isRegisterSuccess
);
